import React, { useState } from 'react'
import styles from './CaddieDisplay.module.scss'
import { useNavigate } from 'react-router-dom'
import { useStateMachine } from 'little-state-machine'
import { updateStore } from '../../store'
import { ModalCaddieProfile } from '../modal/ModalCaddieProfile'

const getCaddieTeamLabel = (teamValue) => {
	if (!teamValue) return null
	const teamMap = {
		spoeum: '스포이음',
		voicecaddie: '보이스캐디',
		mansujung: '만수정',
		other: '기타',
		스포이음: '스포이음',
		보이스캐디: '보이스캐디',
		만수정: '만수정',
		기타: '기타',
	}
	return teamMap[teamValue] || teamValue
}

const CaddieDisplay = ({ caddie, alreadyOfferPage = false }) => {
	const [isProfileModalOpen, setIsProfileModalOpen] = useState(false)
	const navigate = useNavigate()
	const { actions, state } = useStateMachine({ updateStore })

	if (!caddie) return null

	const typeLabel =
		caddie.user_type === 'tourCaddie'
			? '투어 캐디'
			: caddie.user_type === 'houseCaddie'
				? '하우스'
				: ''
	const teamName = caddie.user_tour_caddie?.caddie_team_name
		? getCaddieTeamLabel(caddie.user_tour_caddie.caddie_team_name)
		: null

	const handleProfileClick = (e) => {
		e.stopPropagation()
		setIsProfileModalOpen(true)
	}

	const handleOfferClick = (e) => {
		e.stopPropagation()
		actions.updateStore({
			offerInput: {
				...state.offerInput,
				targetUserId: caddie.id,
				selectedCaddie: caddie,
			},
		})
		navigate('/search?tab=partner')
	}

	return (
		<>
			<div className={styles.caddieDisplayContainer}>
				<div
					className={styles.compactRow}
					onClick={handleProfileClick}
					role="button"
					tabIndex={0}
					onKeyDown={(e) => e.key === 'Enter' && handleProfileClick(e)}
					aria-label="프로필 상세 보기">
					<div className={styles.avatarWrap}>
						<img
							src={caddie.profile_image || '/images/caddie-default-profile.svg'}
							alt=""
							onError={(e) => {
								e.target.src = '/images/caddie-default-profile.svg'
							}}
						/>
					</div>
					<div className={styles.infoWrap}>
						{typeLabel && <span className={styles.typeLabel}>{typeLabel}</span>}
						<span className={styles.name}>{caddie.name}</span>
						{teamName && <span className={styles.team}>{teamName}</span>}
					</div>
					<span className={styles.profileLink}>프로필 상세</span>
				</div>
				{!alreadyOfferPage && (
					<button type="button" className={styles.offerButton} onClick={handleOfferClick}>
						제안하기
					</button>
				)}
			</div>

			<ModalCaddieProfile
				modalVisible={isProfileModalOpen}
				onClose={() => setIsProfileModalOpen(false)}
				user={caddie}
			/>
		</>
	)
}

export default CaddieDisplay
